module.exports = __webpack_public_path__ + "07207143363b172a056e6f329c0a1431.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/sap_america_2022_chart.png
// module id = 1732
// module chunks = 0